(function() {
  'use strict';
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixVariantButtons);
  } else {
    fixVariantButtons();
  }
  
  function fixVariantButtons() {
    // Get variant data from the page
    const variantDataElement = document.querySelector('[data-variant-json]');
    if (!variantDataElement) return;
    
    let variants;
    try {
      variants = JSON.parse(variantDataElement.textContent);
    } catch (e) {
      console.error('Could not parse variant data:', e);
      return;
    }
    
    // Get all variant buttons
    const buttons = document.querySelectorAll('.dynamic-variant-button');
    
    buttons.forEach(button => {
      const optionValue = button.getAttribute('data-option-value');
      
      // Check if ANY variant with this option value is available
      const hasAvailableVariant = variants.some(variant => {
        return variant.options.includes(optionValue) && variant.available;
      });
      
      // Remove disabled class if there's an available variant
      if (hasAvailableVariant) {
        button.classList.remove('disabled');
      }
    });
  }
  
  // Re-run when variant selection changes
  document.addEventListener('change', function(e) {
    if (e.target.classList.contains('dynamic-variant-input')) {
      setTimeout(fixVariantButtons, 100);
    }
  });
})();
